const formatAttendeesSummary = (
  names: readonly string[],
  t: (key: string, options?: Record<string, unknown>) => string,
): string | undefined => {
  if (names.length === 0) return undefined;
  if (names.length === 1) {
    return t('meetings.attendeeSummary.one', { name: names[0] });
  }

  return t('meetings.attendeeSummary.other', {
    name: names[0],
    count: names.length - 1,
  });
};

export { formatAttendeesSummary };
